export default __webpack_public_path__ + "static/media/Transaccion.e13a438d.svg";